import React, { Component } from "react";
import {
  Form,
  Input,
  Button,
  Spin,
  Alert,
  Descriptions,
  Collapse,
  Flex,
} from "antd";
import {
  CheckOutlined,
  ReloadOutlined,
  SafetyCertificateOutlined,
} from "@ant-design/icons";
import "dayjs/locale/th";
import Apiauth from "../../api/Apiauth";
import { openNotification, showToast } from "../../utils";
import SelectedImageNew from "../selectedImageNew";
import { CopyTextToClipboard } from "../../helpers/copy";
import { itemsDescriptions } from "./itemsDescriptions";
const statusFalse = ["NOT_MATCH", "DUPLICATED"];

class VerifySlipOutQrcode extends Component {
  formRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      response: null,
      bankCode: null,
      lableRef: "Reference No.",
      error: null,
      isConfirm: true,
    };
    this.inputRef = React.createRef();
    this.handleFocusAll = this.handleFocusAll.bind(this);
  }

  componentDidMount() {
    this.setState({ lableRef: "Reference No." });
  }
  handleFocusAll() {
    const { uuid } = this.props;
    if (uuid) {
      CopyTextToClipboard(uuid);
    }
    this.inputRef.current.focus({
      cursor: "all",
    });
  }
  handleSubmit = async (values) => {
    const { transRef } = values;
    const { bankCode } = this.state;
    const { uuid } = this.props;
    if (!bankCode) {
      showToast("error", `ไม่พบ bankCode`);
      return;
    }
    if (!uuid) {
      showToast("error", `ไม่พบ uuid`);
      return;
    }
    

    var raw = {
      sendingBank: bankCode,
      transRef: transRef,
      customerUuid: uuid,
    };

    try {
      this.setState({ loading: true, response: null, error: null });

      const apiResponse = await Apiauth.getUploadNoSlip(raw);

      if (apiResponse.status !== 200) {
        const errorData = apiResponse.data;
        showToast(
          "error",
          `API Error: ${apiResponse.status} ${apiResponse.statusText}`
        );
        throw new Error(
          errorData.message ||
            `API Error: ${apiResponse.status} ${apiResponse.statusText}`
        );
      }
      if (statusFalse.includes(apiResponse?.data?.status)) {
        openNotification(
          "warning",
          apiResponse?.data?.status,
          apiResponse?.data?.note
        );
        this.props.handleShowBtnConfirm(false, apiResponse);

        this.setState({
          loading: false,
          response: apiResponse,
          isConfirm: false,
        });
        this.props.handleChangeLoading(false);
        return;
      }

      // Success
      this.props.handleChangeLoading(false);
      this.props.handleShowBtnConfirm(false, apiResponse);

      this.setState({ response: apiResponse, error: null, isConfirm: true });
      showToast("success", "SLIP MATCHED");
    } catch (error) {
      showToast(
        "error",
        `API call error: ${error?.response?.data?.message || error?.message}`
      );
      console.error("API call error:", error);
      this.setState({ error: error, response: null });
    } finally {
      this.setState({ loading: false });
    }
  };

  handleBankChange = (item) => {
    if (item) {
      this.setState({ bankCode: item.bankCode, lableRef: item.lableRef });
    }
  };

  render() {
    const { loading, response, error, lableRef, isConfirm } = this.state;
    const { t, uuid, resAllDataMerchang } = this.props;
    const sharedProps = {
      style: { width: "100%" },
      defaultValue: uuid,
      ref: this.inputRef,
    };
    const descriptionsData = itemsDescriptions({
      resAllDataMerchang: resAllDataMerchang,
      apiResponse: response,
      previewImage: null,
    });
    let columnProps = {
      xxl: 1,
      xl: 1,
      lg: 1,
      md: 1,
      sm: 1,
      xs: 1,
    };
    const genExtra = () => (
      <Flex gap="middle" justify="end" horizontal>
        {isConfirm && (
          <Button
            style={{ fontSize: 13 }}
            type="primary"
            size="small"
            onClick={() => this.props.handleConfirmTransaction(response?.data)}
          >
            <CheckOutlined /> {"Approval"}
          </Button>
        )}
        <Button
          size="small"
          style={{ fontSize: 13 }}
          onClick={() => {
            this.setState({
              response: null,
              isConfirm: false,
            });
          }}
          icon={<ReloadOutlined />}
        >
          {"Reset"}
        </Button>
      </Flex>
    );
    const itemsCollapse = [
      {
        key: "1",
        label: "รายละเอียด...",
        children: (
          <div className="p-1">
            <Descriptions
              bordered
              span={12}
              size="small"
              column={columnProps}
              items={descriptionsData}
            />
          </div>
        ),
        extra: genExtra(),
      },
    ];
    return (
      <>
        {error && (
          <Alert
            message={`statusCode: ${error?.status}`}
            description={error?.response?.data?.message || error?.message}
            type="error"
            showIcon
            closable
            onClose={() => this.setState({ error: null })}
            style={styles.alert}
          />
        )}

        {response && (
          <div style={styles.responseSection}>
            <Alert
              message={response?.data?.status}
              type={
                statusFalse.includes(response?.data?.status)
                  ? "warning"
                  : "success"
              }
              description={response?.data?.note}
              showIcon
            />
            <Collapse
              ghost
              items={itemsCollapse}
              defaultActiveKey={["1"]}
              expandIconPosition="start"
            />
          </div>
        )}
        <div
          // className={`container-sm mt-2 ${!response ? "" : "d-none"}`}
          style={styles.container}
        >
          <Form
            ref={this.formRef}
            layout="vertical"
            onFinish={this.handleSubmit}
            style={styles.form}
            className="mt-2"
          >
            <Form.Item
              name="customer_uuid"
              label="Customer UUID"
              rules={[
                {
                  required: !uuid,
                  message: t("Please required a Customer UUID!"),
                },
              ]}
            >
              <Input
                readOnly
                onClick={this.handleFocusAll}
                {...sharedProps}
                defaultValue={uuid || ""}
                placeholder="กรอก Customer UUID"
              />
            </Form.Item>
            {/*  */}
            <Form.Item
              label="Sending Bank"
              name="sendingBank"
              className=""
              rules={[
                { required: false, message: "Please select the sending bank!" },
              ]}
            >
              <SelectedImageNew onChangBank={this.handleBankChange} />
            </Form.Item>
            <Form.Item
              label={lableRef}
              name="transRef"
              rules={[
                {
                  required: true,
                  message: `กรุณากรอก ${lableRef}!`,
                },
              ]}
            >
              <Input
                placeholder={`กรอก ${lableRef} เช่น 20223xxc582....`}
                disabled={loading}
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                disabled={loading}
                icon={<SafetyCertificateOutlined />}
                style={styles.submitButton}
              >
                {loading ? "Verifying..." : "Verify"}
              </Button>
            </Form.Item>
          </Form>

          {loading && (
            <div style={styles.loadingContainer}>
              <Spin tip="Verifying slip..." fullscreen size="large" />
            </div>
          )}
        </div>
      </>
    );
  }
}

const styles = {
  container: {
    // padding: "30px",
    borderRadius: "8px",
    backgroundColor: "#fff",
    textAlign: "center",
  },
  form: {
    textAlign: "left",
  },
  submitButton: {
    width: "100%",
    height: "40px",
    fontSize: "16px",
    marginTop: "10px",
  },
  loadingContainer: {
    padding: "20px",
    textAlign: "center",
  },
  alert: {
    marginTop: "20px",
  },
  responseSection: {
    // marginTop: "30px",
    // borderTop: "1px dashed #e8e8e8",
    // paddingTop: "20px",
    // textAlign: "left",
  },
  jsonResponse: {
    backgroundColor: "#f0f2f5",
    padding: "15px",
    borderRadius: "4px",
    overflowX: "auto",
    fontFamily: "monospace",
    fontSize: "0.9em",
    color: "#333",
    maxHeight: "300px",
    marginBottom: "20px",
  },
};

export default VerifySlipOutQrcode;
